<template>
    <li>
        <a v-if="data.source !== 'card_only'" :href="data.profile_link" class="card card--backed-white card--horizontal card--profile u-chevron">
            <img v-if="data.photo.url" class="card__image" :alt="data.photo.alt" :src="data.photo.url">
            <div v-else class="card__image card__image--placeholder user">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><title>user</title> <path d="M9.5 11c-3.033 0-5.5-2.467-5.5-5.5s2.467-5.5 5.5-5.5 5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zM9.5 1c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5z"></path> <path d="M17.5 20h-16c-0.827 0-1.5-0.673-1.5-1.5 0-0.068 0.014-1.685 1.225-3.3 0.705-0.94 1.67-1.687 2.869-2.219 1.464-0.651 3.283-0.981 5.406-0.981s3.942 0.33 5.406 0.981c1.199 0.533 2.164 1.279 2.869 2.219 1.211 1.615 1.225 3.232 1.225 3.3 0 0.827-0.673 1.5-1.5 1.5zM9.5 13c-3.487 0-6.060 0.953-7.441 2.756-1.035 1.351-1.058 2.732-1.059 2.746 0 0.274 0.224 0.498 0.5 0.498h16c0.276 0 0.5-0.224 0.5-0.5-0-0.012-0.023-1.393-1.059-2.744-1.382-1.803-3.955-2.756-7.441-2.756z"></path></svg>
            </div>

            <div class="card__details">
                <h3 class="card__title">{{ data.title }} {{ data.name }}</h3>
                <div v-if="data.role" class="card__position">{{ data.role }}</div>
                <div v-if="data.description" class="card__description">{{ data.description }}</div>
                <span v-if="data.email" class="card__tag ki-email u-accent">{{ data.email }}</span>
                <span v-if="data.telephone" class="card__tag ki-phone u-accent">{{ data.telephone }}</span>
            </div>
        </a>
        <div v-else class="card card--backed-white card--horizontal card--profile u-chevron">
            <img v-if="data.photo.url" class="card__image" :alt="data.photo.alt" :src="data.photo.url">
            <div v-else class="card__image card__image--placeholder user">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><title>user</title> <path d="M9.5 11c-3.033 0-5.5-2.467-5.5-5.5s2.467-5.5 5.5-5.5 5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zM9.5 1c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5z"></path> <path d="M17.5 20h-16c-0.827 0-1.5-0.673-1.5-1.5 0-0.068 0.014-1.685 1.225-3.3 0.705-0.94 1.67-1.687 2.869-2.219 1.464-0.651 3.283-0.981 5.406-0.981s3.942 0.33 5.406 0.981c1.199 0.533 2.164 1.279 2.869 2.219 1.211 1.615 1.225 3.232 1.225 3.3 0 0.827-0.673 1.5-1.5 1.5zM9.5 13c-3.487 0-6.060 0.953-7.441 2.756-1.035 1.351-1.058 2.732-1.059 2.746 0 0.274 0.224 0.498 0.5 0.498h16c0.276 0 0.5-0.224 0.5-0.5-0-0.012-0.023-1.393-1.059-2.744-1.382-1.803-3.955-2.756-7.441-2.756z"></path></svg>
            </div>

            <div class="card__details">
                <h3 class="card__title">{{ data.title }} {{ data.name }}</h3>
                <div v-if="data.role" class="card__position">{{ data.role }}</div>
                <div v-if="data.description" class="card__description">{{ data.description }}</div>
                <span v-if="data.email" class="card__tag ki-email u-accent">{{ data.email }}</span>
                <span v-if="data.telephone" class="card__tag ki-phone u-accent">{{ data.telephone }}</span>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    props: {
        data: Object
    },
    data() {
        return {
            person_description: ''
        }
    },
    methods: {
        strip(html) {
            var tmp = document.createElement("div");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        trim_and_elipsis(string) {
            if(string.length >= 80) {
                return string.substring(0,80) + '...';
            }
        }
    },
    created() {
        this.person_description = this.strip(this.data.description);

        // Add elipsis if values too long (separate line for readability only)
        this.person_description = this.trim_and_elipsis(this.person_description);
    }
}
</script>